{
  "menu": {
    "dashboard": "Dashboard",
    "individuals": "Individuals",
    "nonIndividualClients": "Non-individual Entities",
    "households": "Households",
    "portfolioManagement": "Portfolios",
    "clientManagement": "Clients",
    "corporations": "Corporations",
    "modelPortfolios": "Model Portfolios",
    "modelPortfoliosV2": "Model Portfolios v2",
    "buildModels": "Build Models",
    "modelFamily": "Model Family",
    "portfolioTemplates": "Templates",
    "productShelfPage": "Product Shelf",
    "assetClassesPage": "Asset Classes",
    "tradingSchedules": "Trading Schedules",
    "trading": "Trading",
    "reports": "Reports",
    "rebalanceDashboard": "Rebalance Dashboard",
    "rebalancing": "Rebalancing",
    "bulkTrader": "Bulk Trader",
    "bulkTraderRevamp": "Bulk Trader (Revamp)",
    "bulkImport": "Bulk Import",
    "taxLossHarvesting": "Tax-Loss Harvesting",
    "compliance": "Compliance",
    "flagPolicies": "Flag Policies",
    "complianceReview": "Compliance Review",
    "transactionMonitoringTool": "Transaction Monitoring Tool",
    "elderlyClients": "Elderly Clients",
    "bankAccountsToReview": "New Bank Accounts Approval",
    "institutionsToReview": "Institutions Approval",
    "operations": "Operations",
    "reconciliation": "Reconciliation",
    "flags": "Flags",
    "activities": "Activities",
    "transactions": "All Transactions",
    "accountsReview": "Accounts Review",
    "settings": "Settings",
    "orgSettings": "Organization",
    "newsAndInsights": "News and Insights",
    "devSettings": "Integration",
    "bulkUpsertRequests": "Bulk Upsert Requests",
    "language": "Language",
    "logout": "Logout",
    "addNewEntity": "Add new profile",
    "viewAllProfiles": "View all profiles",
    "resourcesArticles": "Resources and Articles",
    "contactSupport": "Contact Support",
    "actions": "Actions",
    "statementsReview": "Statements Review",
    "systemManagement": "Settings",
    "rebalanceReport": "Rebalance Report",
    "portfolioOptimizer": "Portfolio Optimizer",
    "annualSuitabilityReview": "Annual Profile Information Update",
    "feeAndBilling": "Fees & Billing",
    "billingManagement": "Billing Management",
    "feeGrids": "Fee Grids",
    "billingSchedules": "Billing Schedules",
    "incurredFees": "Billing Management",
    "workflows": "Workflows",
    "configureWorkflow": "Configure Workflow",
    "pageConfiguration": "Configure Page",
    "staticPageWidgetConfiguration": "Configure Static Page Widget",
    "clientReportTemplate": "Client Report Template",
    "formTemplateEditor": "Form Template Editor",
    "general": "General",
    "theme": "Theme",
    "designer": "Designer",
    "textDesigner": "Text Design",
    "authenticationTheme": "Authentication Designer",
    "errorTheme": "Error Page",
    "roles": "Roles",
    "roleSettings": "Role Settings",
    "users": "Users",
    "authentication": "Authentication",
    "accessSettings": "Access Settings",
    "custodianAndAccounts": "Accounts",
    "accounts": "Available Accounts",
    "accountsList": "Accounts",
    "accountGroupsList": "Account Groups",
    "custodianConnections": "Custodian Connections",
    "productExperience": "Product Experience",
    "dashboards": "Dashboards",
    "localization": "Localization",
    "notifications": "Notifications",
    "alertBanners": "Alert Banners",
    "forms": "Forms",
    "statementsAndTaxDocuments": "Statements & Tax Documents",
    "customFields": "Custom Fields",
    "repCodes": "Rep Codes",
    "pageConfigurations": "Page Configurations",
    "staticPageWidgetConfigurations": "Static Page Widget Configurations",
    "downtimeSchedule": "Downtime Schedule",
    "transfers": "Transfers",
    "trades": "Trades",
    "assetClasses": "Asset Classes",
    "portfolioManagements": "Portfolio Management",
    "portfolioManagementSettings": "Portfolio Management Settings",
    "feesAndBilling": "Fees & Billing",
    "feeSettings": "General",
    "embedded": "Embedded",
    "apiTokens": "API Tokens",
    "webhooks": "Webhooks",
    "integrations": "Integrations",
    "accessUsers": "Access Users",
    "clientReports": "Client Reports",
    "roleProfiles": "Role Profiles",
    "taxRankings": "Tax Rankings",
    "localizationConfiguration": "Localization Configuration",
    "generalProductExperience": "General",
    "formDefinitions": "Form Definitions",
    "formMapper": "Form Mapper",
    "featureFlags": "Feature Flags",
    "homePageConfiguration": "Home Page Configuration",
    "homePageConfigurations": "Home Page Configurations",
    "customAttributeLabels": "Custom Attribute Labels",
    "accountSettings": "Account Settings",
    "accountGroupSettings": "Account Group Settings",
    "configurableTablePages": "Configurable Table Pages",
    "configurableTablePage": "Configurable Table Page"
  }
}
